import type { FC, ReactNode } from "react";

export interface DiscountedPriceProps {
  currentPrice: ReactNode;
  originalPrice: ReactNode;
  className?: string;
  currentPriceClassName?: string;
  originalPriceClassName?: string;
}

const DiscountedPrice: FC<DiscountedPriceProps> = ({
  currentPrice,
  originalPrice,
  className,
  currentPriceClassName,
  originalPriceClassName,
}) => {
  return (
    <span className={className}>
      <span className={currentPriceClassName}>
        <span className="sr-only">Current price: </span>
        {currentPrice}
      </span>
      <s className={originalPriceClassName}>
        <span className="sr-only">Original price: </span>
        {originalPrice}
      </s>
    </span>
  );
};

export default DiscountedPrice;
